<template>
	<div
		class="site_button"
		:class="[theme, type]"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button"
	>
		<span v-html="type === 'close' ? 'Close' : 'Menu'"></span>

		<div class='icon'>
			<svg
				v-if="type === 'close'"
				xmlns="http://www.w3.org/2000/svg"
				width="24.042"
				height="24.042"
				viewBox="0 0 24.042 24.042"
			>
				<g
					id="Hamburger-Close"
					transform="translate(-301.98 -687.281)"
				>
					<line
						id="Line_2"
						data-name="Line 2"
						x2="32"
						transform="translate(302.687 710.615) rotate(-45)"
						fill="none"
						stroke="#ddfc70"
						stroke-width="2"
					/>
					<line
						id="Line_1"
						data-name="Line 1"
						x2="32"
						transform="translate(302.687 687.988) rotate(45)"
						fill="none"
						stroke="#ddfc70"
						stroke-width="2"
					/>
				</g>
			</svg>

			<svg
				v-if="type === 'open'"
				xmlns="http://www.w3.org/2000/svg"
				width="37"
				height="14"
				viewBox="0 0 37 14"
			>
				<g
					id="Hamburger"
					transform="translate(0 1)"
				>
					<line
						id="Line_2"
						data-name="Line 2"
						x2="37"
						transform="translate(0 12)"
						fill="none"
						stroke="#ddfc70"
						stroke-width="2"
					/>
					<line
						id="Line_1"
						data-name="Line 1"
						x2="37"
						fill="none"
						stroke="#ddfc70"
						stroke-width="2"
					/>
				</g>
			</svg>

		</div>

	</div>
</template>

<script>
import Close from '../../images/close_X.svg';
import Open from '../../images/menu.svg';

export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
			open: Open,
			close: Close,
		};
	},

	props: {
		label: {},
		theme: {
			default: 'light',
		},
		type: {
			default: 'normal',
		},
	},

	computed: {},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
	display: inline-flex;
	flex-direction: column-reverse;
	transition: 0.2s ease all;
	text-decoration: none;
	justify-content: center;
	align-items: center;
	position: relative;
	border-radius: 0;
	background: transparent;
	align-items: center;
	gap: 2px;
	/* width: 40px;
	height: 40px; */

	.scrolled & {
		span {
			color: var(--midnight);
		}

		svg {
			display: flex;
			/* max-width: 24px;
			max-height: 12px; */
			/* margin-left: 8px; */

			&::v-deep {
				line {
					stroke: var(--cobalt);
				}
			}
		}
	}

	@media (hover) {
		&:hover {
			transition: 0.2s ease all;
			cursor: pointer;

			span {
				transition: 0.2s ease all;
			}
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal 700 12px/14px var(--primary-font-family-heading);
		transition: 0.2s ease all;
		margin-right: 0;
		position: relative;
		z-index: 10;
		color: var(--midnight);
		text-transform: uppercase;
	}

	.icon {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 23px;
	}

	svg {
		display: flex;
		/* max-width: 24px;
		max-height: 12px;
		margin-left: 8px; */

		&::v-deep {
			line {
				stroke: var(--cobalt);
			}
		}
	}
}
</style>
